module.exports = __webpack_public_path__ + "static/img/6.2afe991.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/colectivo-de-vida/6.png
// module id = me1g
// module chunks = 0